import { render, staticRenderFns } from "./HiboRadioButton.vue?vue&type=template&id=039f4f94&"
import script from "./HiboRadioButton.vue?vue&type=script&lang=ts&"
export * from "./HiboRadioButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports